var unirest = require('unirest');
const axios = require('axios').default;


const API = require ('Api') ;


const apiBase = process.env.REACT_APP_API_BASE ;
const endpointBase = 'school/' ;


export async function getSchoolCalendarLevels ( calendarID ) {
    const res =  await unirest.get(apiBase + endpointBase   + "calendars/" + calendarID+ "/levels" )
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function getSchoolLevel ( levelID ) {
    const res =  await unirest.get(apiBase + endpointBase +  "levels/" + levelID)
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function getSchoolLevelCourses ( levelID ) {
    const res =  await unirest.get(apiBase + endpointBase  + "levels/" + levelID + "/courses" )
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}


export async function getEnrollFile( token, personaID, calendarID ) {
   const res =  await unirest.get(API.V2 + API.ENROLL + personaID  )
            .headers({'Authorization': 'Bearer ' + token, 
            'crrntcal':calendarID, 
            'Content-Type': 'application/json'})
            if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function uploadEnrollFile (  token, personaID, calendarID, reqID, data ) {
 
    const res = await axios
    .post( API.V2 + API.ENROLL + personaID + '/reqs/' + reqID, data, { headers : {'Authorization': 'Bearer ' + token, 
                                                                                //'Content-Type': 'multipart/form-data',
                                                                                'crrntcal':calendarID} }) ;

    return res.body;
     

}

export async function deleteEnrollFile ( token, personaID, reqID, fileID ) {

    const res =  await unirest.delete(API.V2 + API.ENROLL + personaID + '/reqs/'+ reqID + '/' + fileID )
            .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
            
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function enrollStudentCourse ( token, personaID, calendarID, courseID ) {

    const res =  await unirest.post(API.V2 + API.ENROLL + personaID + '/course/' + courseID )
            .headers({'Authorization': 'Bearer ' + token, 
            'crrntcal':calendarID, 
            'Content-Type': 'application/json'})
            .send()
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

